/** Contains level 1 menu entry/name like ‚who we are‘ ‘innovation‘ */
export function usePageCategory(pathname = location.pathname) {
  const uriParts = pathname.split('/').filter(Boolean);
  if (uriParts.length === 0) {
    return "home";
  }
  return uriParts[0];
}